import axios from './axios.client.js';

// Get all lead stages
export const getLeadStages = async () => {
  try {
    const response = await axios.get('/lead-stages');
    return response.data;
  } catch (error) {
    console.error('Error fetching lead stages:', error);
    throw error;
  }
};

// Get a single lead stage
export const getLeadStage = async (id) => {
  try {
    const response = await axios.get(`/leadStages/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching lead stage:', error);
    throw error;
  }
};

// Create a new lead stage
export const createLeadStage = async (leadStageData) => {
  try {
    const response = await axios.post('/leadStages', leadStageData);
    return response.data;
  } catch (error) {
    console.error('Error creating lead stage:', error);
    throw error;
  }
};

// Update a lead stage
export const updateLeadStage = async (id, leadStageData) => {
  try {
    const response = await axios.put(`/leadStages/${id}`, leadStageData);
    return response.data;
  } catch (error) {
    console.error('Error updating lead stage:', error);
    throw error;
  }
};

// Delete a lead stage
export const deleteLeadStage = async (id) => {
  try {
    const response = await axios.delete(`/leadStages/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting lead stage:', error);
    throw error;
  }
};

// Upload lead stages from CSV
export const uploadLeadStages = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post('/leadStages/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading lead stages:', error);
    throw error;
  }
};

// Extract lead stage fields from text using NLP
export const extractLeadStageFields = async (text, provider = 'openai') => {
  try {
    const response = await axios.post('/leadStages/extract-fields', {
      text,
      provider,
    });
    return response.data;
  } catch (error) {
    console.error('Error extracting lead stage fields:', error);
    throw error;
  }
};
